import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navigation from '../components/Navigation';
import { auth, googleProvider, signInWithRedirect } from '../firebase';
import './SignUpPage.css';

function SignUpPage() {
  const navigate = useNavigate();

  const handleGoogleSignIn = async () => {
    try {
      await signInWithRedirect(auth, googleProvider);
      // Note: The redirect will happen automatically, no need to navigate
    } catch (error) {
      console.error('Error signing up with Google:', error);
    }
  };

  return (
    <div>
      <Navigation hideLogin={true} />
      <div className="signup-container">
        <div className="signup-content">
          <h1 className="signup-title">Join WTF Fertility</h1>
          <p className="signup-subtitle">Create your account to start your fertility journey</p>
          
          <button onClick={handleGoogleSignIn} className="google-signin-button">
            <img 
              src="/google-icon.svg" 
              alt="Google" 
              className="google-icon"
            />
            Sign up with Google
          </button>

          <p className="signup-disclaimer">
            By signing up, you agree to our Terms of Service and Privacy Policy
          </p>
        </div>
      </div>
    </div>
  );
}

export default SignUpPage; 